import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "src/shared/utilities/graphql/apolloClient";

import { useOHData } from "../../redux/hooks/openHousesHooks";
import { useUIBehavior, useUIData } from "../../redux/hooks/uiHooks";
import OpenHouseItemHDP from "../OpenHouseItemHDP";
import SuggestSignup from "../SuggestSignup";
import * as S from "./styled";

const HDPOpenHouses = () => {
  const { listingAddress, listingLink, openHouses, registeredOH } = useOHData();
  const { isSectionExpanded } = useUIData();
  const { closeSection, expandSection } = useUIBehavior();
  const openHousesListToDisplay = isSectionExpanded
    ? openHouses
    : [openHouses[0]];

  return (
    <>
      {!!openHouses.length && (
        <ApolloProvider client={apolloClient}>
          <S.Wrapper>
            <S.CalendarIcon />
            <S.ListWrapper>
              <S.ExpandableSection isExpanded={isSectionExpanded}>
                <S.ListTitle>Open Houses</S.ListTitle>
                {openHousesListToDisplay.map(openHouse => (
                  <OpenHouseItemHDP
                    key={`${openHouse.open_house_id}-oh-item`}
                    byApptOnly={openHouse.by_appt_only}
                    endsAt={openHouse.ends_at}
                    id={openHouse.open_house_id}
                    numberOfRegisteredUsers={
                      openHouse.number_of_registered_users
                    }
                    openHouseData={{
                      listingAddress,
                      listingLink,
                      time: {
                        startsAt: openHouse.starts_at,
                        endsAt: openHouse.ends_at
                      },
                      streamingUrl: openHouse.meeting_url
                    }}
                    startsAt={openHouse.starts_at}
                    userIsRegistered={registeredOH.includes(
                      openHouse.open_house_id
                    )}
                  />
                ))}
              </S.ExpandableSection>
              {openHouses.length > 1 && (
                <S.ExpandButton
                  onClick={() =>
                    isSectionExpanded ? closeSection() : expandSection()
                  }
                >
                  <S.ChevronIcon isExpanded={isSectionExpanded} />
                  {isSectionExpanded
                    ? "See less"
                    : `See ${openHouses.length - 1} more`}
                </S.ExpandButton>
              )}
            </S.ListWrapper>
            <SuggestSignup />
          </S.Wrapper>
        </ApolloProvider>
      )}
    </>
  );
};

export default HDPOpenHouses;
